import '@nectary/components/button'
import '@nectary/components/icon'
import '@nectary/components/skeleton'
import '@nectary/components/skeleton-item'
import '@nectary/components/text'
import styled from 'styled-components'

const Root = styled.div`
  width: calc(100vw - 68px);
  height: 100%;
  display: block;
  padding: 24px;
`

const CenteredContentWrapper = styled.div`
  margin: 24px auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 24px;
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  padding: 15px;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 390px;
  background-color: #f7f9fa;
  border-radius: 24px;
  padding: 32px;
  gap: 24px;
`

export const ContainerSkeleton = () => {
  return (
    <Root>
      <CenteredContentWrapper>
        <LogoContainer>
          <LogoWrapper>
            <Logo>
              <sinch-skeleton-item size='l' style={{ width: '100%', height: '100%' }} />
            </Logo>
          </LogoWrapper>
          <sinch-skeleton-item size='l' style={{ width: '320px' }} />
        </LogoContainer>
        <ContentWrapper>
          <sinch-skeleton-item size='l' style={{ width: '80%' }} />
          <sinch-skeleton-item size='l' style={{ width: '60%' }} />
          <sinch-skeleton-item size='l' style={{ width: '70%' }} />

          <sinch-skeleton-item size='l' style={{ width: '60%', height: '180px', alignSelf: 'center' }} />

          <sinch-skeleton-item size='l' style={{ width: '80%' }} />
          <sinch-skeleton-item size='l' style={{ width: '60%' }} />

          <sinch-skeleton-item size='l' style={{ width: '70%', alignSelf: 'center' }} />
        </ContentWrapper>
      </CenteredContentWrapper>
    </Root>
  )
}
